export class FeatureToggleResponse {
  constructor(
    public name: string,
    public active: boolean,
  ) {}
}
